@if (dashboardSummaryData()) {
  <div class="flex flex-wrap lg:grid lg:grid-cols-4 gap-2">
    <div class="card mb-0 h-25 w-full">
      <p>Pedidos Pendentes</p>
      <h4 class="text-primary-500 font-bold mt-2">
        {{ dashboardSummaryData()?.underReviewOrdersCount ?? "-" }}
      </h4>
    </div>

    <div class="card mb-0 h-25 w-full">
      <p>Pedidos em Transporte</p>
      <h4 class="text-primary-500 font-bold mt-2">
        {{ dashboardSummaryData()?.shippedOrdersCount ?? "-" }}
      </h4>
    </div>

    <div class="card mb-0 h-25 w-full">
      <p>Produtos Ativos</p>
      <h4 class="font-bold mt-2">
        {{ dashboardSummaryData()?.activeProductsCount ?? "-" }}
      </h4>
    </div>

    <div class="card mb-0 h-25 w-full">
      <p>Leads na Fila</p>
      <h4 class="font-bold mt-2">
        {{ dashboardSummaryData()?.leadsInQueueCount ?? "-" }}
      </h4>
    </div>

    <div class="card h-25 w-full">
      <p>Contratos Ativos</p>
      <h4 class="font-bold mt-2">
        {{ dashboardSummaryData()?.activeOrdersCount ?? "-" }}
      </h4>
    </div>

    <div class="card mb-0 h-25 w-full">
      <p>Recebidos Hoje</p>
      <h4 class="font-bold mt-2">
        {{ dashboardSummaryData()?.totalReceivedToday ?? "-" | currency }}
      </h4>
    </div>

    <div class="card mb-0 h-25 w-full">
      <p>Receita Prevista (Semana)</p>
      <h4 class="font-bold mt-2">
        {{ dashboardSummaryData()?.expectedRevenueThisWeek ?? "-" | currency }}
      </h4>
    </div>

    <div class="card mb-0 h-25 w-full">
      <p>Inadimplência (>7 dias)</p>
      <h4 class="font-bold mt-2">
        {{
          (dashboardSummaryData()?.defaulterPercentage?.toFixed(2) ?? "0") + "%"
        }}
      </h4>
    </div>
  </div>

  <div class="flex flex-wrap lg:flex-nowrap gap-2 mt-3">
    <div class="card w-full lg:w-1/2">
      <div class="flex justify-between">
        <p class="font-bold">Esteira de Pedidos</p>
        <a routerLink="/orders" class="text-primary-500"> Ver todos </a>
      </div>

      <div class="w-full mt-5">
        @if (dashboardSummaryData()?.underReviewOrders?.length) {
          <div class="space-y-2">
            @for (
              item of dashboardSummaryData()?.underReviewOrders;
              track item.orderId
            ) {
              <div
                class="rounded-lg bg-gray-100 flex flex-wrap justify-between p-3"
              >
                <div>
                  <p class="font-bold">
                    {{ item.customerFullName }}
                  </p>
                  <small class="text-gray-500">
                    {{ item.underReviewAt | timeFromNow }}
                  </small>
                </div>
                <div class="flex gap-2 items-center">
                  <app-tag-status text="Aguardando Análise" />
                  <a
                    pButton
                    rounded
                    [routerLink]="'/orders/details/' + item.orderId"
                    class="btn btn-primary"
                  >
                    Analisar
                  </a>
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="mt-2 text-center">Nenhum pedido sob analise</p>
        }
      </div>
    </div>

    <div class="card w-full lg:w-1/2">
      <p class="font-bold">Radar de Atrasos</p>

      <div class="w-full mt-5">
        @if (dashboardSummaryData()?.overdueInstallments?.length) {
          <div class="space-y-2">
            @for (
              item of dashboardSummaryData()?.overdueInstallments;
              track item.orderId
            ) {
              <div
                class="rounded-lg bg-gray-100 flex flex-wrap justify-between p-3"
              >
                <div>
                  <p class="font-bold">
                    {{ item.customerFullName }}
                  </p>
                  <small class="text-gray-500">
                    {{ item.dueDate | timeFromNow }}
                  </small>
                </div>
                <div class="flex gap-2 items-center">
                  <p class="font-bold">
                    {{ item?.totalOverdueAmount ?? 0 | currency }}
                  </p>
                  <a
                    pButton
                    rounded
                    [routerLink]="'/orders/details/' + item.orderId"
                    class="btn btn-primary"
                  >
                    Ver detalhes
                  </a>
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="mt-2 text-center">Nenhum pedido com pagamento atrasado</p>
        }
      </div>
    </div>
  </div>
}

<p-toast />
